import Sortable from 'sortablejs';

export default function () {
    const elements = document.querySelectorAll('[data-sort]');

    for (let inc = 0; inc < elements.length; ++inc) {
        const element = elements[inc];
        let url =  "/panel/methods/"
        const sortable = Sortable.create(element, {
            animation: 150,
            ghostClass: 'ghost',
            handle: '.drag-handler',
            onUpdate: function () {
                const method = element.getAttribute('data-sort');
                const itemsList = new Array();

                element.querySelectorAll('[data-item-id]').forEach(function (item) {
                    itemsList.push(parseInt(item.getAttribute('data-item-id')));
                });

                var req = { items: itemsList };
                
                if (element.getAttribute('data-sort-param')) {
                    req.rawParam = element.getAttribute('data-sort-param');
                }

                fetch(`${url}Sort${method}`,
                    {
                        method: 'POST',
                        body: JSON.stringify(req),
                        headers: {
                            'Content-Type': 'application/json; charset=utf-8'
                        }
                    }).then(() => {
                        window.toast('Kolejność została zmieniona');
                      
                    }).catch(error => {
                        console.log(error);
                    });
            }
        });
    }
}